import React, { useContext } from 'react';

import { FlagsContext } from 'src/context/flagsContext';

import { HeaderSlotContext } from '../AppShell/HeaderSlotContext';
import Layout, { LayoutProps } from '../Layout';

/**
 * Thin shim used when EnableNewAppLayout is ON.
 * Sets the header slot to null (hides AppBar content in AppShell)
 * and renders children as a pass-through.
 */
const ChannelsPageLayoutShim: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const headerSlotCtx = useContext(HeaderSlotContext);

  React.useEffect(() => {
    if (!headerSlotCtx) return;
    headerSlotCtx.setHeader(null);
    return () => {
      headerSlotCtx.clearHeader();
    };
  }, [headerSlotCtx]);

  return <>{children}</>;
};

export const ChannelsPageLayout: React.FC<LayoutProps> = ({
  children,
  ...others
}) => {
  const { EnableNewAppLayout } = useContext(FlagsContext);

  if (EnableNewAppLayout) {
    return <ChannelsPageLayoutShim>{children}</ChannelsPageLayoutShim>;
  }

  return (
    <Layout disableGutters hasNavbar={false} {...others}>
      {children}
    </Layout>
  );
};
